export const sortAttributesByOrder = (attributes) => {
    if (!attributes || attributes.length === 0) return attributes;
    return [...attributes].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
};
